import*as l from"../../../../rollup-plugin-node-polyfills/polyfills/events.js";var o=l.EventEmitter;export{o as s};
